import {
  DateField,
  Field,
  StringField,
} from '../../util/components/resource/resource-fields/resource-fields';
import { ApiResource } from '../api-resource';
import { Endpoint } from '../api.decorators';
import { Child } from '../child/child.model';
import { Course } from '../course/course.model';
import { Payment } from '../payment/payment.model';
import { Workshop } from '../workshop/workshop.model';
import { format } from 'date-fns';
import { getTargetScheduleInterval } from '../_lib/schedule';

@Endpoint('registrations', 'Registration')
export class Registration extends ApiResource<Registration> {
  @Field({ label: $localize`Attendant` })
  attendant!: Child;

  @Field({ includeFilter: false })
  payment?: Payment;

  @Field({ type: () => Course, label: $localize`Course` })
  course?: Course;

  @Field({ type: () => Workshop, label: $localize`Workshop` })
  workshop?: Workshop;

  @StringField({ label: $localize`Extra information camp` })
  extraInformationCamp?: string;

  @StringField({ label: $localize`Extra information office` })
  extraInformationOffice?: string;

  @DateField({ readonly: true, label: $localize`Reserved until` })
  reservedUntil!: Date | null;

  // todo: use getters from course.name and workshop.name when castToEntity is made recursive
  get name() {
    return this.course
      ? this.course.theme.name
      : this.workshop
        ? this.workshop.theme.name
        : '';
  }

  override toLabel(): string {
    return (
      new Child(this.attendant).toLabel() +
      ' - ' +
      this.name +
      ' @ ' +
      format(getTargetScheduleInterval(this.rootTarget).start, 'dd/MM/yyyy')
    );
  }

  get target() {
    const target = this.course ?? this.workshop;
    if (!target) throw new Error('Registration is missing a target');
    return target;
  }

  get rootTarget() {
    const target = this.course?.camp ?? this.workshop;
    if (!target) throw new Error('Registration is missing a rootTarget');
    return target;
  }
}
